import { useMutation } from '@tanstack/react-query';

import { api } from '@/lib/api';

interface LoginRequest {
  email: string;
}

interface LoginApiRequest {
  email: string;
}

export function useLogin() {
  return useMutation({
    mutationFn: async (data: LoginRequest) => {
      const payload: LoginApiRequest = {
        email: data.email,
      };
      await api.post('auth/login', { json: payload });
      // Returns nothing (204 No Content - sends magic link email)
    },
  });
}
